import axios from 'axios/lib/axios';
import { stringToCamelCase } from '../helpers/stringHelpers.js';

const base = '/api/v1/properties/';
const timeout = 30000;

const endpoints = {
  getSpaces: function () {
    return axios.get(`${base}spaces`, {
      timeout: timeout,
    });
  },
  getAmenities: function (id) {
    return axios.get(`${base}spaces/${id}/amenities`, {
      timeout: timeout,
    });
  },
  getIssues: function (id) {
    return axios.get(`${base}amenities/${id}/issues`, {
      timeout: timeout,
    });
  },
  getCauses: function (id) {
    return axios.get(`${base}caused-by`, {
      timeout: timeout,
    });
  },
  createWorkRequest: function (propertyRef, data) {
    return axios.post(`${base}${propertyRef}/work-requests`, data, {
      timeout: timeout,
    });
  },
  uploadPhoto: function (propertyRef, data) {
    return axios.post(`${base}${propertyRef}/upload-photo`, data, {
      timeout: timeout,
    });
  },
};

export default endpoints;
